module.exports = __webpack_public_path__ + "media/images/emblems/Horriwil-blason-6bd62cb5b1b16cc6efa89d0541fb3d37.png";